/**
 * Payment Slice — Types & Initial State
 *
 * Matches Smithy model: FintechLastMileBeaconSmithyModel/model/fetch-payments.smithy
 * API: POST /payments/fetch (1–100 IDs per call)
 *
 * Single slice handles both single-payment detail and bulk lookups.
 */

/** A single entry in the status timeline. */
export interface StatusTimelineEntry {
  status: string;
  state: string;
  enteredAt: string;
  exitedAt: string | null;
  statusLatencyMs: number | null;
  latencyFromPreviousMs: number | null;
  cumulativeLatencyMs: number;
  phaseDetails: string | null;
}

/** Linked execution IDs by execution type (PAIN_001, PAIN002, etc.). */
export type ExecutionIdsMap = Record<string, string[]>;

/** Full payment response from POST /payments/fetch. */
export interface PaymentResponse {
  id: string;
  disbursementId: string | null;
  paymentType: string | null;
  clientId: string | null;
  pluginName: string | null;
  beaconPaymentStatus: string;
  beaconPaymentState: string;
  firstStatusAt: string | null;
  totalLatencyMs: number | null;
  statusTimeline: StatusTimelineEntry[];
  paystationDisbursementStatus: string | null;
  paystationDetailedStatusCode: string | null;
  paystationDetailedStatusCodeCategory: string | null;
  executionIds: ExecutionIdsMap | null;
  createdAt: string;
  updatedAt: string;
}

/** Response from POST /payments/fetch. */
export interface FetchPaymentsResponse {
  payments: PaymentResponse[];
  notFound: string[];
}

/** Redux slice state — holds single or bulk payment results. */
export interface PaymentState {
  data: PaymentResponse | null;
  bulkData: FetchPaymentsResponse | null;
  loading: boolean;
  bulkLoading: boolean;
  error: string | null;
  bulkError: string | null;
  currentRequestId: string | null;
  bulkRequestId: string | null;
}

export const paymentInitialState: PaymentState = {
  data: null,
  bulkData: null,
  loading: false,
  bulkLoading: false,
  error: null,
  bulkError: null,
  currentRequestId: null,
  bulkRequestId: null,
};
